/* eslint-disable quotes */
import {
  retrieveCard,
  updateCustomerPaymentCardBackend,
  updateDefaultCard,
} from '../../api';
import { deleteCustomerPaymentCardBackend } from '../../api/backend';
import store from '../../redux/store';
import { showMessageModal, showPaymentModal } from '../../redux/actions';
import {
  logLowError,
  logLowLog,
  logMediumError,
  logMediumLog,
} from '../../utils/logger';

type ChangeDefaultCreditCardParams = {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedCard: React.Dispatch<React.SetStateAction<any>>;
  newCardId: any;
};

export const changeDefaultCreditCard = async ({
  setLoading,
  setSelectedCard,
  newCardId,
}: ChangeDefaultCreditCardParams) => {
  try {
    logLowLog(`Updating default card to ${newCardId}`);
    const { user, userConnected } = store.getState().userReducer;
    const { customerId } = user;
    setLoading(true);
    if (userConnected) {
      const { stripeCustomerId } = user;
      const card = await retrieveCard({
        cardId: newCardId,
        customerId,
      });
      if (card?.customer) {
        logMediumLog('Updating default source on stripe', { user });
        await updateDefaultCard({
          cardId: newCardId,
          stripeCustomerId,
          customerId,
        });
      }
      await updateCustomerPaymentCardBackend(newCardId);
    }
    setLoading(false);
    setSelectedCard({});
    store.dispatch(showPaymentModal(false));
  } catch (error) {
    logMediumError(`Error updating default credit card: ${error}`);
    store.dispatch(
      showMessageModal(
        "Nous n'avons pas pu modifier votre carte par défaut. Veuillez réessayer ou ajouter une nouvelle carte bancaire.",
      ),
    );
    setLoading(false);
  }
};

export const deleteCB = async (cardId: any) => {
  try {
    await deleteCustomerPaymentCardBackend(cardId);
    store.dispatch(
      showMessageModal(
        `Nous vous confirmons la suppression de votre carte bancaire`,
      ),
    );
  } catch (error) {
    store.dispatch(
      showMessageModal(
        `Nous n'avons pas pu supprimer votre carte bancaire, veuillez essayer de nouveau.`,
      ),
    );
    logLowError(`Error deleting user CB ${error}`);
  }
};
